module.exports = __webpack_public_path__ + "static/beng-496874fb1faf5fa0ec2728cb9df9d5ab.jpg";